// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.informations-ac {
  padding: 0;
}

.informations-ac__entete {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 2.4rem;
}

.informations-ac__entete h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #374151;
  margin: 0;
}

/* Meme retour que les pages Login / ForgotPassword : gris au repos, orange au survol. */
.informations-ac__retour {
  align-self: flex-start;
  color: #6b7280;
  font-size: 1.3rem;
  text-decoration: none;
  transition: color 0.15s;
}

.informations-ac__retour:hover {
  color: #f97316;
}

.informations-ac__chargement {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 4rem 2rem;
  color: #6b7280;
  font-size: 1.4rem;
}

.informations-ac__chargement .spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: informations-ac-spin 1s linear infinite;
}

@keyframes informations-ac-spin {
  to {
    transform: rotate(360deg);
  }
}

.informations-ac .tab-nav {
  margin-bottom: 2.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/InformationsAC/InformationsAC.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,wFAAwF;AACxF;EACE,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".informations-ac {\n  padding: 0;\n}\n\n.informations-ac__entete {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  margin-bottom: 2.4rem;\n}\n\n.informations-ac__entete h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #374151;\n  margin: 0;\n}\n\n/* Meme retour que les pages Login / ForgotPassword : gris au repos, orange au survol. */\n.informations-ac__retour {\n  align-self: flex-start;\n  color: #6b7280;\n  font-size: 1.3rem;\n  text-decoration: none;\n  transition: color 0.15s;\n}\n\n.informations-ac__retour:hover {\n  color: #f97316;\n}\n\n.informations-ac__chargement {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n  padding: 4rem 2rem;\n  color: #6b7280;\n  font-size: 1.4rem;\n}\n\n.informations-ac__chargement .spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: informations-ac-spin 1s linear infinite;\n}\n\n@keyframes informations-ac-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.informations-ac .tab-nav {\n  margin-bottom: 2.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
